class ResizeEvents {
	constructor() {

		var timer,
			orientationchanged = true,
			newOrientation,
			$window = $(window),
			oldOrientation = $window.width() > $window.height() ? 'landscape' : 'portrait';

		$window.resize(function () {
			if (timer) {
				clearTimeout(timer);
			}

			timer = setTimeout(function () {
				if (mobileCheck.isMobile) {
					newOrientation = $window.width() > $window.height() ? 'landscape' : 'portrait';
					orientationchanged = newOrientation !== oldOrientation;
					oldOrientation = newOrientation;
					if (!orientationchanged) {
						$window.trigger('mobileResize');
					}
				}

				if (orientationchanged) {
					$window.trigger('customResize');
				}
			}, 100);
		});

		$window.on('customResize', function () {
			resizeCallbacks.forEach(function (callback) {
				try {
					callback.resize();
				} catch (error) {
					console.log('Starterkit : Missing resize function in object ' + callback.constructor.name);
				}
			});
		});

		$window.on('mobileResize', function () {
			mobileResizeCallbacks.forEach(function (callback) {
				try {
					callback.resize();
				} catch (error) {
					console.log('Starterkit : Missing resize function in object ' + callback.constructor.name);
				}
			});
		});
	}
}
